import { render, staticRenderFns } from "./RuleCustomList.vue?vue&type=template&id=18bb7dac&scoped=true"
import script from "./RuleCustomList.vue?vue&type=script&lang=js"
export * from "./RuleCustomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb7dac",
  null
  
)

export default component.exports